import React from 'react';
import PropTypes from 'prop-types';
import { NavCard } from '../../ui';

const MecaBanner = ({ title, dataList }) => {
  return (
    <div
      className="container"
      style={{
        marginTop: 15,
        marginBottom: 15,
      }}
    >
      <div
        style={{
          marginBottom: 30,
        }}
      >
        <center>
          <h1>{title}</h1>
        </center>
      </div>
      <NavCard dataList={dataList} />
    </div>
  );
};

MecaBanner.propTypes = {
  title: PropTypes.string,
  dataList: PropTypes.array,
};

export default MecaBanner;



// WEBPACK FOOTER //
// ./src/components/Main/services/MecaBanner.js